"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prefixer_1 = __importDefault(require("./prefixer"));
const value_to_string_1 = __importDefault(require("./value-to-string"));
const get_class_name_1 = __importDefault(require("./get-class-name"));
function getCss(propertyInfo, value) {
    let rules;
    const valueType = typeof value;
    if (valueType !== 'string' && valueType !== 'number') {
        if (process.env.NODE_ENV !== 'production') {
            const name = propertyInfo.jsName;
            const encodedValue = JSON.stringify(value);
            console.error(`📦 ui-box: property “${name}” was passed invalid value “${encodedValue}”. Only numbers and strings are supported.`);
        }
        return null;
    }
    const valueString = value_to_string_1.default(value, propertyInfo.defaultUnit);
    const className = get_class_name_1.default(propertyInfo, valueString);
    if (propertyInfo.isPrefixed) {
        rules = prefixer_1.default(propertyInfo.jsName || '', valueString);
    }
    else {
        rules = [{ property: propertyInfo.cssName || '', value: valueString }];
    }
    let styles;
    if (process.env.NODE_ENV === 'production') {
        const rulesString = rules
            .map(rule => `${rule.property}:${rule.value}`)
            .join(';');
        styles = `.${className}{${rulesString}}`;
    }
    else {
        const rulesString = rules
            .map(rule => `  ${rule.property}: ${rule.value};`)
            .join('\n');
        styles = `
.${className} {
${rulesString}
}`;
    }
    return { className, styles };
}
exports.default = getCss;
//# sourceMappingURL=get-css.js.map